import { SalaryHead, SalaryGroupHead, SalaryGroup, SalaryPrice, SalaryPeriod } from '@/plugins/api'
import alert from '@/plugins/alert'
import { rangeRight, sortBy } from 'lodash-es'

export default {
  namespaced: true,
  state: {
    headFees: [],
    headFee: {},
    createdSalaryHead: {},
    groupHeadFee: null,
    salaryGroups: [],
    pageText: '',
    router: '',
    itemsPerPage: 10,
    searchParams: {},
    totalItems: 0,
    loading: false,
    isSubFee: null
  },
  actions: {
    async fetchHeadsIndependent(_, params) {
      try {
        return await SalaryHead.fetch(params)
      } catch (error) {
        alert.error('Đã có lỗi xảy ra: ' + error)
      }
    },
    async fetchHead({ commit }, id) {
      commit('setHead', await SalaryHead.fetchOne(id))
    },
    async fetchSalaryGroup({ commit }, payload) {
      commit('setSalaryGroup', await SalaryGroup.fetch(payload))
    },
    async createHead({ dispatch, commit }, payload) {
      try {
        const headFee = await SalaryHead.create(payload)
        dispatch('filterheadFee', { id: headFee.id })
        commit('changeState', { createdSalaryHead: headFee })
        alert.addSuccess()
      } catch {
        // alert.addError(error)
      }
    },
    async updateHead({ dispatch, commit }, payload) {
      try {
        commit('updateHead', await SalaryHead.update(payload.id, payload.data))
        dispatch('requestPageSettings', {})
        alert.updateSuccess()
      } catch {
        // alert.updateError(error)
      }
    },
    async deleteHead({ dispatch }, payload) {
      await SalaryHead.remove(payload.id)
      dispatch('requestPageSettings', { type: payload.type })
    },
    async fetchGroupHead({ commit }, idHeadFee) {
      let groupHeadFees = await SalaryGroupHead.fetch({ _sort: 'createdAt:asc', salary_head: idHeadFee })
      groupHeadFees = sortBy(groupHeadFees, [
        function(o) {
          return o.createdAt
        }
      ])
      let periods = await SalaryPeriod.fetch()
      groupHeadFees.map(element => {
        if (element.prices.length > 0) {
          return element.prices.map(price => (price.period = periods[periods.findIndex(x => x.id === price.period)]))
        }
      })
      commit('setGroupHeadFee', await groupHeadFees)
    },
    async createGroupHead({ dispatch, commit }, payload) {
      let params = {
        period: payload.period,
        scope: payload.scope,
        group: payload.group && payload.group.id,
        salary_head: payload.salary_head.id
      }
      if (payload.period === 'month') {
        const result = await SalaryGroupHead.create(params)
        dispatch('fetchGroupHead', payload.salary_head.id)
        commit('createGroupHead', result)
        return result
      } else {
        const result = await SalaryGroupHead.create(params)
        commit('createGroupHead', result)
        return result
      }
    },
    async createPriceGroupHeadFee({ commit }, payload) {
      commit('updateGroupHeadFee', await SalaryGroupHead.createPrice(payload))
    },
    async deletePriceGroupHeadFee({ commit }, payload) {
      commit(
        'updateGroupHeadFee',
        await SalaryGroupHead.removePrice(payload.groupHeadFeeId, { priceId: payload.idPrice })
      )
    },
    async updatePriceGroupHeadFee({ commit }, payload) {
      let price = await SalaryPrice.update(payload.id, payload.price)
      payload.groupHeadFee = {
        ...payload.groupHeadFee,
        prices: payload.groupHeadFee.prices.map(item => (item.id === price.id ? price : item))
      }
      commit('updateGroupHeadFee', payload.groupHeadFee)
    },
    async deleteGroupHead({ commit }, payload) {
      try {
        await SalaryGroupHead.remove(payload)
        commit('deleteGroupHead', payload)
        alert.deleteSuccess()
      } catch (error) {
        alert.deleteError(error)
      }
    },
    async filterheadFee({ commit, state, dispatch }, query) {
      const searchParams = {
        ...query,
        _limit: state.itemsPerPage,
      }

      let type = query.type
      if (!type && state.router.includes('sub')) {
        type = state.isSubFee ? 'sub' : 'sum'
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', { category: query.category, type })
    },
    async setSearchParam({ commit, state }) {
      const searchParams = {
        ...state.searchParams,
      }
      commit('changeState', { searchParams })
    },
    async setRouter({ commit }, category) {
      if (category === 'main') commit('changeState', { router: 'main' })
      else if (category === 'adjust') commit('changeState', { router: 'adjust' })
      else if (category === 'sub-sum') commit('changeState', { router: 'sub-sum', isSubFee: false })
      else if (category === 'sub-minus') commit('changeState', { router: 'sub-minus', isSubFee: true })
    },
    clean({ commit }) {
      commit('clean')
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage, category, type }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'title:ASC',
          category,
          type
        }
        const [totalItems, headFees] = await Promise.all([
          SalaryHead.count(searchParams),
          SalaryHead.search(searchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            headFees,
            totalItems,
            itemsPerPage,
            searchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },
    async reset({ commit }) {
      commit('changeState', { groupHeadFee: null, headFee: {} })
    }
  },
  mutations: {
    setHeads(state, headFees) {
      state.headFees = headFees
    },
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    setHead(state, headFee) {
      state.headFee = headFee
    },
    updateHead(state, headFee) {
      state.headFee = headFee
    },
    setGroupHeadFee(state, groupHeadFee) {
      state.groupHeadFee = groupHeadFee
    },
    createGroupHead(state, payload) {
      state.groupHeadFee.push(payload)
    },
    updateGroupHeadFee(state, payload) {
      state.groupHeadFee = state.groupHeadFee.map(item => (item.id === payload.id ? payload : item))
    },
    deleteGroupHead(state, id) {
      state.groupHeadFee = state.groupHeadFee.filter(item => !(item.id === id))
    },
    setSalaryGroup(state, salaryGroups) {
      state.salaryGroups = salaryGroups
    },
    clean(state) {
      state.headFees = []
      state.itemsPerPage = 10
      state.searchParams = {}
      state.totalItems = 0
    }
  }
}
